import { useCanViewEmails } from '../../../helpers/useCanViewEmails';
import React, { useRef, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { USER } from '../../../enums';
import Modal from '../../modules/Modal';
import { useHotkeys } from 'react-hotkeys-hook';
import styles from './RenotifyUserModal.module.scss';
import { postResendRegistrationLink } from '../../../api';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';

type TCreateUserModal = {
  open: boolean;
  switchModal: () => void;
  fetchData: () => Promise<any>;
  renotifyUsers: USER[] | 'all' | null;
};

const promptText = {
  all: 'Resend registration link to all not active users email',
  user: 'Resend registration link to user email',
};
const RenotifyUserModal: React.FC<TCreateUserModal> = ({ open, switchModal, fetchData, renotifyUsers }) => {
  const canViewEmails = useCanViewEmails();
  const notification = useSnackbar();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  const onClose = () => {
    switchModal();
  };

  const onSubmit = async () => {
    if (!renotifyUsers) return;
    setLoading(true);
    try {
      const body: any = {};
      if (renotifyUsers === 'all') {
        body.all = 'all';
      } else if (renotifyUsers?.length) {
        body.userIds = renotifyUsers.map((u) => u.id);
      }
      await postResendRegistrationLink(body);
      await fetchData();
      onClose();
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={onClose} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalHeader}>{renotifyUsers === 'all' ? promptText.all : promptText.user}</div>
        {canViewEmails && (<div className={styles.email}>{renotifyUsers && renotifyUsers !== 'all' && renotifyUsers[0]?.email}</div>)}
        <div className={styles.disclaimer}>You can send a registration email to the user(s) only once every 24 hours.</div>

        <div className={styles.actionBtns}>
          <ContainedButton onClick={onSubmit}>
            <div ref={submitButtonRef}>Send</div>
          </ContainedButton>
          <OutlinedButton onClick={onClose} kind="default">
            Cancel
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default RenotifyUserModal;
